<template>
<div class="formGroup" :data-layout="layout">
  <div class="formGroup__body">
    <formLabel :label="label" :validation="validation"></formLabel>
    <input
      class="formControl"
      v-model="value"
      type="range"
      ref="input"
      :data-error="errors.has(name)"
      :max="max"
      :min="min"
      :step="step"
      @change="update"
    >
  </div>
  <div class="formGroup__footer">
    <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
    <slot></slot>
  </div>
</div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-slider',
  mixins: [mixin],
  data() {
    return {
      value: '0'
    }
  },
  props: {
    name: {
      type: String,
      default: '',
      required: false
    },
    max: String,
    min: String,
    step: String
  }
}</script>

<style>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormSlider.vue